import React, { useState, useEffect } from "react"
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import moment from "moment"
import clockIcon from "../../assets/images/clock-icon.svg"
import infoIcon from "../../assets/images/info_black.svg"
import { connect } from "react-redux"
import { TiresBottomNav } from "../../layouts/TiresLayout"
import { navigationPaths } from "../../constants/paths"
import { gaJSON, trackFirebaseAnalytics } from "../../helpers/googleAnalyticsHelpers"

const SelectInstallationDateTime = ({ shop, dispatch, history, vehicle, user }) => {
  const today = new Date()

  const [selectedDate, setSelectedDate] = useState(moment(today).add(9, "day").toDate())
  const [appointmentTimes, setAppointmentTimes] = useState([])
  const [selectedTime, setSelectedTime] = useState(null)
  const [slotLoading, setSlotLoading] = useState(false)
  const [showCalendar, setShowCalendar] = useState(true)

  const fetchTimeSlots = (date) => {
    setSlotLoading(true)
    dispatch({
      type: "TIRE_FETCH_TIMESLOTS_SAGA",
      payload: {
        shopId: shop.id,
        date: moment(date).format("YYYYMMDD"),
        callback: (data) => {
          if (Array.isArray(data) && data.length > 0) {
            setAppointmentTimes(data[0].times || [])
          } else {
            setAppointmentTimes([])
          }
          setSlotLoading(false)
        }
      }
    })
  }

  useEffect(() => {
    fetchTimeSlots(today)
  }, [])

  const handleDateChange = (date) => {
    setSelectedDate(date)
    setSelectedTime(null)
    fetchTimeSlots(date)
  }

  const handleTimeChange = (time) => {
    setSelectedTime(time)
  }

  const continueFnc = () => {
    trackFirebaseAnalytics({
      event: gaJSON.date_time_selected,
      params: {
        vehicle_id: vehicle.id,
        user_role: user.roles.toString()
      }
    })

    dispatch({
      type: "TIRES_SET_INSTALLATION_DATE_TIME",
      payload: {
        date: selectedDate,
        time: selectedTime
      }
    })

    history.push({
      pathname: navigationPaths.tireConfirmation()
    })
  }

  return (
    <>
      <h2 className="text-lg font-semibold !my-4 text-center tires-step-header">
        Step 5 / 6: Select Installation Date & Time
      </h2>
      <div className="select-date-time-container !mb-[100px] max-w-[670px]">
        <div className="delivery-info-banner">
          <img src={clockIcon} className="clock-icon" />
          <p>
            Tire delivery takes about 6 business days. We block appointments during this time to
            ensure your tires arrive before your appointment.
          </p>
        </div>
        <div className="calendar-container">
          <div className="calendar-border">
            <div className="calendar-header" style={{ marginBottom: showCalendar ? "1rem" : "0" }}>
              <span className="step-circle">1</span>
              <span className="step-label">Select date</span>
              <span
                className={`dropdown-icon${showCalendar ? " open" : ""}`}
                style={{ cursor: "pointer", transition: "transform 0.2s" }}
                onClick={() => setShowCalendar((prev) => !prev)}
              >
                ⌃
              </span>
            </div>
            {showCalendar && (
              <DatePicker
                inline
                selected={selectedDate}
                onChange={handleDateChange}
                minDate={moment(today).add(9, "day").toDate()}
                renderCustomHeader={({
                  date,
                  decreaseMonth,
                  increaseMonth,
                  prevMonthButtonDisabled,
                  nextMonthButtonDisabled
                }) => {
                  if (!date || typeof date.getFullYear !== "function") return null
                  return (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: 8
                      }}
                    >
                      <span style={{ fontWeight: 600, fontSize: 14 }}>
                        {moment(date).format("MMMM YYYY")}
                      </span>
                      <div style={{ display: "flex", gap: 8 }}>
                        <button
                          style={{ fontSize: 14, fontWeight: 600 }}
                          onClick={decreaseMonth}
                          disabled={prevMonthButtonDisabled}
                        >
                          {"<"}
                        </button>
                        <button
                          style={{ fontSize: 14, fontWeight: 600 }}
                          onClick={increaseMonth}
                          disabled={nextMonthButtonDisabled}
                        >
                          {">"}
                        </button>
                      </div>
                    </div>
                  )
                }}
              />
            )}
          </div>
          <p />
          <div className="calendar-border">
            <div className="calendar-header">
              <span className="step-circle">2</span>
              <span className="step-label">Select time</span>
            </div>
            {slotLoading ? (
              <div style={{ textAlign: "center", marginTop: "20px" }}>Loading time slots...</div>
            ) : (
              <>
                <div className="install-time-banner">
                  <img src={infoIcon} className="info-icon" />
                  <p>
                    Tire install times vary by shop. Some may ask you to drop off your car, while
                    others allow you to wait onsite.{" "}
                    <b>Most shops estimate about 1.5 to 2 hours.</b>
                  </p>
                </div>
                <div className="time-slots-list" style={{ marginTop: 16, marginBottom: 16 }}>
                  {appointmentTimes.length === 0 ? (
                    <div>No available appointment times for this date.</div>
                  ) : (
                    <>
                      {appointmentTimes.map((slot, idx) => (
                        <button
                          key={idx}
                          className={`time-slot-btn${selectedTime === slot ? " selected" : ""}`}
                          onClick={() => handleTimeChange(slot)}
                        >
                          {moment(slot, "HH:mm").format("h:mm A")}
                        </button>
                      ))}
                    </>
                  )}
                </div>
                <div className="appointment-notification-banner">
                  <img src={clockIcon} className="clock-icon" />
                  <p>We'll text you once your appointment is confirmed.</p>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
      <TiresBottomNav
        next={continueFnc}
        nextDisabled={selectedTime && selectedDate}
        goBack={() => history.goBack()}
      />
    </>
  )
}

const mapStateToProps = (state) => {
  const user = state.application.userSessionData || (state.users && state.users.currentUser)
  return {
    user: user,
    shop: state.tires.selectedShop,
    vehicle: state.tires.vehicle
  }
}

export default connect(mapStateToProps)(SelectInstallationDateTime)
